module.exports = "/static/assets/1fa6345d57ffc67eccd9f44cf6a383dd.svg";